import { useEffect, useState, useLayoutEffect } from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import moment from 'moment';

import axios from 'axios';
import './App.css';

import logo from './assets/images/HFL_logo.png';

// Components
import Spinner from './components/Spinner';
import FixtureItem from './components/FixtureItem';

function App() {
	// Fixture Data State
	const [fixtureData, setFixtureData] = useState({});
	const [filteredResults, setFilteredResults] = useState({});

	// Loading State
	const [isLoading, setIsLoading] = useState(false);

	// Fetch fixture data on render
	useEffect(() => {
		// Team ID
		const teamId = document.getElementById('root').getAttribute('data-team-id');

		// Club ID
		const clubId = document.getElementById('root').getAttribute('data-club-id');

		// Fetch Data
		const fetchData = async () => {
			try {
				setIsLoading(true);
				await axios
					.get(
						'https://hfl-api-strapi.herokuapp.com/api/streams/upcoming/preview',
						{
							headers: {
								'Access-Control-Allow-Origin': '*',
							},
						}
					)
					.then((res) => {
						if (!res.data || res.data.length < 1) {
							return;
						}
						filterByClub(res);
					});
			} catch (error) {
				console.log(error);
				setIsLoading(false);
			}
		};

		// Find Club games
		const filterByClub = (res) => {
			if (teamId) {
				let result = res.data.filter((fixture) => {
					return (
						fixture.home_team.id === Number(teamId) ||
						fixture.away_team.id === Number(teamId)
					);
				});
				sortDate(result);
				setIsLoading(false);
			} else if (clubId) {
				let result = res.data.filter((fixture) => {
					return (
						fixture.home_team.club_id === Number(clubId) ||
						fixture.away_team.club_id === Number(clubId)
					);
				});
				sortDate(result);
				setIsLoading(false);
			} else {
				setFilteredResults(res.data);
				setIsLoading(false);
			}
		};
		fetchData();
	}, []);

	// Get fixtures only today or future...
	const sortDate = (data) => {
		let result = data?.filter((fixture) => {
			// const fixtureDateTime =
			// 	fixture.startTime.slice(0, 10) +
			// 	'T' +
			// 	fixture.startTime.slice(21, 29) +
			// 	'.000+01:' +
			// 	fixture.startTime.slice(33);
			let fixtureDate = fixture.date;
			let today = new Date();
			today.setHours(0, 0, 0, 0);
			// Check if game date is from today onwards
			return new Date(fixtureDate).toISOString() >= today.toISOString();
		});
		// setFixtureData(result);
		setFilteredResults(result);

		return result;
	};

	// Handle Scroll Click
	const scroll = (e) => {
		let container = document.getElementById('widget-content');
		sideScroll(container, e.target.id, 25, 50, 100);
	};

	// Scroll Banner
	const sideScroll = (element, direction, speed, distance, step) => {
		let scrollAmount = 0;
		let slideTimer = setInterval(() => {
			if (direction === 'left') {
				element.scrollLeft -= step;
			} else {
				element.scrollLeft += step;
			}
			scrollAmount += step;
			// Stop scroll when end is reached
			if (scrollAmount >= distance) {
				window.clearInterval(slideTimer);
			}
		}, speed);
	};

	const handleLogoClick = () => {
		window.top.location.href = 'https://hfl.vercel.app';
	};

	const handleArchiveClick = (e) => {
		e.preventDefault();
		window.top.location.href = 'https://hfl.vercel.app/streams/archive';
	};

	const handleUploadClick = () => {
		window.top.location.href = 'https://hfl.vercel.app/streams/submit';
	};

	return (
		<div className={`App ${isLoading ? 'loading' : undefined}`}>
			<>
				<div className='widget-logo'>
					<img src={logo} alt='Hoopsfix Live' onClick={handleLogoClick} />
					<form>
						<button
							className='btn-primary archive-btn'
							onClick={(e) => handleArchiveClick(e)}
							value='Go to Archive'
						>
							Archive
						</button>
					</form>
				</div>
				<div
					className={`widget-content ${isLoading === false ? '' : 'no-data'} ${
						filteredResults && Object.keys(filteredResults).length > 0
							? ''
							: 'no-data'
					}`}
					id='widget-content'
				>
					{
						// If is loading return Loading spinner
						isLoading ? (
							<Spinner />
						) : // Check data received has fixtures
						filteredResults && Object.keys(filteredResults).length > 0 ? (
							Object.keys(filteredResults).map((key, i) => {
								return (
									<>
										{filteredResults[key].map((fixture) => {
											const startTime = moment(fixture.startTime);
											const threeHoursAgo = moment().subtract(3, 'hours');
											if (startTime.isAfter(threeHoursAgo)) {
												return (
													<FixtureItem
														key={i}
														fixture={fixture}
														fixtureData={fixtureData}
														gameDate={key}
													/>
												);
											}
										})}
									</>
								);
							})
						) : (
							// If data has no fixtures, return No Data string
							<div>
								<p className='no-data-msg'>No Upcoming Streams.</p>
								<button
									className='btn-primary upload-btn'
									onClick={handleUploadClick}
								>
									Upload your stream here
								</button>
							</div>
						)
					}
				</div>
				<div className='widget-controls'>
					<button className='nav-btn' id='left' onClick={(e) => scroll(e)}>
						<MdKeyboardArrowLeft size={12} />
					</button>
					<button className='nav-btn' id='right' onClick={(e) => scroll(e)}>
						<MdKeyboardArrowRight size={12} />
					</button>
				</div>
			</>
		</div>
	);
}

export default App;
